export interface PaymentAccountDetails {
  iban: string | null;
  bic: string | null;
}

/** Resolve the lease account; legacy SCI fields cover records without an assignment. */
export function leasePaymentDetails(
  lease: { sci_payment_accounts?: PaymentAccountDetails | null } | null | undefined,
  sci: PaymentAccountDetails | null | undefined,
): PaymentAccountDetails {
  return {
    iban: lease?.sci_payment_accounts?.iban ?? sci?.iban ?? null,
    bic: lease?.sci_payment_accounts?.bic ?? sci?.bic ?? null,
  };
}

export function sameIban(left: string | null | undefined, right: string | null | undefined): boolean {
  return !!left && !!right && left.replace(/\s/g, '').toUpperCase() === right.replace(/\s/g, '').toUpperCase();
}

/** ISO 13616 format and mod-97 check for newly entered payment accounts. */
export function isValidIban(value: string): boolean {
  const iban = value.replace(/\s/g, '').toUpperCase();
  if (!/^[A-Z]{2}[0-9]{2}[A-Z0-9]{11,30}$/.test(iban)) return false;
  const rearranged = iban.slice(4) + iban.slice(0, 4);
  let remainder = 0;
  for (const character of rearranged) {
    const code = character.charCodeAt(0);
    const digits = code <= 57 ? character : String(code - 55);
    for (const digit of digits) remainder = (remainder * 10 + Number(digit)) % 97;
  }
  return remainder === 1;
}
